//hemos instalado jwt-decode
import { jwtDecode } from "jwt-decode";

export const hasexpiredToken = (token) => {
  if (!token || token.split(".").length !== 3) {
    console.error("Token is invalid:");
    return true; // O maneja este caso según convenga
  }
  const { exp } = jwtDecode(token); //obtenemos la fecha de expiracion del token y la guardamos en exp
  const currentData = new Date().getTime() / 1000; //obtenemos la fecha actual y la guardamos en currentData
  if (exp <= currentData) {
    //si la fecha de expiracion es menor o igual a la fecha actual
    return true;
  }
  return false;
};

/**
 * Devuelve el instante de caducidad del token en milisegundos, o null si no se
 * puede leer. Lo usa AuthContext para renovar ANTES de que caduque, en vez de
 * esperar a que el servidor conteste 403 en mitad de una sesion con paciente.
 */
export const getTokenExpiryMs = (token) => {
  if (!token || token.split(".").length !== 3) return null;
  try {
    const { exp } = jwtDecode(token);
    return typeof exp === "number" ? exp * 1000 : null;
  } catch (error) {
    return null;
  }
};
